export interface InboxPaths {
  InboxView: string,
  InboxThreadView: string,
}

export const inboxPaths: InboxPaths = {
  InboxView: '/advisor/inbox/view',
  InboxThreadView: '/advisor/inbox/thread/:id',
};